import React from "react";
import PropTypes from "prop-types";

/**
 * Komponent pokazujący próbę połączenia z merchantem
 */
class P24MerchantConnectionTest extends React.Component {

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit();
    };

    connectionSuccess = () => {
        return (
            <div>
                <p>Połączenie nawiązane z merchantem {this.props.merchant.name} ({this.props.merchant.p24MerchantId})</p>
            </div>
        )
    }

    connectionFailure = () => {
        return (
            <div className="w3-text-red">
                <p>Brak połączenia z merchantem {this.props.merchant.name} ({this.props.merchant.p24MerchantId})</p>
            </div>
        )
    }

    /**
     * @param {Boolean} isConnection czy jest połączenie
     */
    connectionResult = (isConnection) => {
        if (isConnection) {
            return <this.connectionSuccess />
        }
        return <this.connectionFailure />
    }

    render() {
        return (
            <div className="w3-card-4">
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">{this.props.title} - {this.props.p24ImplementationType.displayText}</h2>
                </div>

                <div className="w3-row-padding">

                    <div>
                        <span>
                            &nbsp;
                        </span>

                        {this.connectionResult(this.props.p24MerchantTestConnection.result)}

                        <span>
                            &nbsp;
                        </span>

                    </div>

                </div>

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            {this.props.submitText}
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}

P24MerchantConnectionTest.defaultProps = {
    title: "Test połączenia",
    submitText: 'Zamknij'
}

P24MerchantConnectionTest.propTypes = {
    //tytul formularza
    title: PropTypes.string.isRequired,
    //wybramy merchant
    merchant: PropTypes.object.isRequired,
    //jaki typ implementacji wybieramy (FORM/REST/SOAP)
    p24ImplementationType: PropTypes.object.isRequired,
    //wynik
    p24MerchantTestConnection: PropTypes.object.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired,
    //tekst na akcji zapisz
    submitText: PropTypes.string.isRequired
}

export default P24MerchantConnectionTest;